/** @format */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  homefieldIconFulfillmentAvailabilityFill,
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
} from '@dsg-tech/homefield-angular-icons';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';

@Component({
  selector: 'compare-components-skeleton-fulfillment-section',
  imports: [HomefieldIconLibraryModule, HmfSkeletonComponent],
  templateUrl: './skeleton-fulfillment-section.component.html',
  styleUrl: './skeleton-fulfillment-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonFulfillmentSectionComponent {
  private readonly hmfIconService = inject(HomefieldIconsLibraryService);

  constructor() {
    this.hmfIconService.registerIcons([homefieldIconFulfillmentAvailabilityFill]);
  }
}
